<template>
    <div :id="`${id}_cont`" class="form-group pb-2" v-if="showContent">
        <label v-if="title" :for="id" class="title form-label">{{ title }}</label>
        <input :id="id" class="form-control datetimepicker" :placeholder="placeholder" :value="formattedModelValue" />
    </div>
    <!-- Loading -->
    <div :id="`${id}_cont`" v-else>
        <div class="form-group pb-2">
            <label v-if="title" class="title placeholder-glow col-3">
                <span class="placeholder col-12"></span>
            </label>
            <div class="placeholder-glow">
                <input class="form-control placeholder col-12" />
            </div>
        </div>
    </div>
</template>

<script>
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/es.js";

export default {
    name: "VsudDate",
    props: {
        title: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "Selecciona una fecha",
        },
        isRequired: Boolean,
        modelValue: {
            type: String,
            default: " "
        },
        withTime: {
            type: Boolean,
            default: false
        },
        onlyHours: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showContent: false,
            minLoadTime: 1500,
            loadStart: null,
            fp: null,
        };
    },
    computed: {
        formattedModelValue() {
            if (this.modelValue && !this.withTime) {
                return this.modelValue.split('T')[0];
            }
            return this.modelValue;
        }
    },
    mounted() {
        this.loadStart = Date.now();
        window.addEventListener("load", this.onLoad);
        setTimeout(() => {
            this.showContent = true;
        }, this.minLoadTime);
    },
    updated() {
        this.initializeFlatpickr();
    },
    beforeUpdate() {
        if (this.fp) {
            this.fp = null;
        }
    },
    beforeUnmount() {
        window.removeEventListener("load", this.onLoad);
    },
    methods: {
        initializeFlatpickr() {
            if (!this.fp) {
                let flatpickrOptions = {
                    altInput: true,
                    altFormat: "d/m/Y",
                    dateFormat: "Y-m-d",
                    locale: "es",
                    defaultDate: this.modelValue || "",
                    onClose: (selectedDates, dateStr) => {
                        if (dateStr) {
                            let newDate;
                            if (this.withTime) {
                                newDate = new Date(dateStr).toISOString();
                            } else {
                                const localDate = new Date(dateStr + 'T00:00:00');
                                newDate = localDate.toISOString().split('T')[0];
                            }
                            // console.log("newDate", newDate)
                            this.$emit("update:modelValue", newDate);
                        }else{
                            this.$emit("update:modelValue", "");
                        }
                    },
                };

                if (this.withTime) {
                    flatpickrOptions.enableTime = true;
                    // El formato mostrado es de 24 hrs. Sin esto el selector queda en
                    // 12 hrs con AM/PM y la caja de la hora no acepta valores sobre 12.
                    flatpickrOptions.time_24hr = true;
                    flatpickrOptions.altFormat = "d/m/Y H:i";
                    flatpickrOptions.dateFormat = "Y-m-d H:i";

                    if (this.onlyHours) {
                        flatpickrOptions.minuteIncrement = 60;
                        flatpickrOptions.defaultMinute = 0;
                    }
                }

                this.fp = flatpickr(`#${this.id}`, flatpickrOptions);

                if (this.fp && this.fp.calendarContainer) {
                    this.fp.calendarContainer.addEventListener("focusin", (event) => event.stopPropagation());
                }
            }
        },
        onLoad() {
            const loadTime = Date.now() - this.loadStart;
            if (loadTime >= this.minLoadTime) {
                this.showContent = true;
            } else {
                setTimeout(() => {
                    this.showContent = true;
                }, this.minLoadTime - loadTime);
            }
        },
    },
};
</script>


<style scoped>
.title {
    color: var(--black);
    font-size: 0.9rem;
    font-weight: 500;
}
</style>
